
import { queryClient } from "@/index";
import { getTenant } from "../../../../TENANT_CONFIGS";
import { annotationExplorerConfigs } from "../configs/_EXPORTS";
  

  
  
  export const getAnnoExplorerConfigsForThisTenant = () => {
    const {SELF_MANAGED_BASE_CONFIGS} = queryClient.getQueryData('platformConfigs')
    const selfManagedAnnoExplorerConfigs = SELF_MANAGED_BASE_CONFIGS?.annotationExplorerConfigs;
    return selfManagedAnnoExplorerConfigs || annotationExplorerConfigs[getTenant()]
  }
  